import styled, { css } from 'styled-components'

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

const placeholderStyles = `
  color: #bfbfbf;
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  opacity: 1;
`

export const InputWrapper = styled.div<{ $hasError: boolean }>`
  .ant-input {
    box-sizing: border-box;
    height: 40px;
    padding: 8px 12px;
    border-width: 2px;
    border-radius: 4px;
    font-family: Roboto, sans-serif;
    font-size: 14px;
    line-height: 24px;
    color: #363636;
    border-color: ${({ $hasError }) => ($hasError ? '#f5222d' : '#d9d9d9')};

    &::placeholder {
      ${placeholderStyles}
    }

    &::-webkit-input-placeholder {
      ${placeholderStyles}
    }

    &::-moz-placeholder {
      ${placeholderStyles}
    }

    &:-ms-input-placeholder {
      ${placeholderStyles}
    }

    &:hover {
      border-color: ${({ $hasError }) => ($hasError ? '#f5222d' : '#40a9ff')};
    }

    &:focus {
      border-color: ${({ $hasError }) => ($hasError ? '#f5222d' : '#40a9ff')};
      box-shadow: none;
    }

    &:disabled {
      background: #f5f5f5;
      color: rgba(0, 0, 0, 0.25);
    }
  }
`
